// src/components/Hero.js
import React, { useRef, useState, useEffect } from "react";

// Particles
function Particles() {
  const [isSecondVisit, setIsSecondVisit] = useState(false);	
  useEffect(() => {
	  const visited = sessionStorage.getItem("homeVisited");

	  if (visited) {
		setIsSecondVisit(true);
	  } else {
		sessionStorage.setItem("homeVisited", "true");
	  }

	  const initParticles = () => {
		const container = document.getElementById("particles-js");

		if (!container) return;

		// destruir instancias previas
		if (window.pJSDom && window.pJSDom.length) {
		  window.pJSDom.forEach((p) => {
			try {
			  if (
				p &&
				p.pJS &&
				p.pJS.fn &&
				p.pJS.fn.vendors &&
				typeof p.pJS.fn.vendors.destroypJS === "function"
			  ) {
				p.pJS.fn.vendors.destroypJS();
			  }
			} catch (e) {}
		  });

		  window.pJSDom = [];
		}

		container.innerHTML = "";

		requestAnimationFrame(() => {
		  if (window.particlesJS) {
			window.particlesJS("particles-js", {
			  /* config */
			});

			setTimeout(() => {
			  window.dispatchEvent(new Event("resize"));
			}, 200);
		  }
		});
	  };

	  initParticles();

	  return () => {
		if (window.pJSDom && window.pJSDom.length) {
		  window.pJSDom.forEach((p) => {
			try {
			  if (
				p &&
				p.pJS &&
				p.pJS.fn &&
				p.pJS.fn.vendors &&
				typeof p.pJS.fn.vendors.destroypJS === "function"
			  ) {
				p.pJS.fn.vendors.destroypJS();
			  }
			} catch (e) {}
		  });

		  window.pJSDom = [];
		}

		const container = document.getElementById("particles-js");

		if (container) {
		  container.innerHTML = "";
		}
	  };
	}, []);

  return (
    <div
      className={`dwb_layer ${isSecondVisit ? "particles-hide" : ""}`}
      id="particles-js"
    />
  );
}

// Parallax Layers
const parallaxLayers = [
  { id: "dwb-0", speed: 2 },
  { id: "dwb-1", speed: 5 },
  { id: "dwb-2", speed: 11, extraClass: "x1" },
  { id: "dwb-3", speed: 16 },
  { id: "dwb-4", speed: 26 },
  { id: "dwb-5", speed: 36 },
  { id: "dwb-6", speed: 49 },
  { id: "dwb-7", speed: 69 },
  { id: "dwb-8", speed: 100 },
];

function ParallaxLayer({ id, speed, extraClass }) {
  return <div className={`dwb_layer parallax ${extraClass || ""}`} id={id} data-speed={speed} />;
}

// Click handlers
function handleClick() {
  window.open(
    "https://www.disegnowebologna.com/presupuesto/index1.html",
    "_blank",
    "noopener,noreferrer"
  );
}

function handleClick1() {
  window.open("whatsapp.php", "_blank", "noopener,noreferrer");
}

function AudioPlayer() {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlayPause = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <div className="speaker">
      <audio ref={audioRef} onEnded={() => setIsPlaying(false)}>
        <source src="music/Romanian.mp3" type="audio/mp3" />
        <source src="music/Romanian.ogg" type="audio/ogg" />
      </audio>

      <button className="play-btn" onClick={handlePlayPause}>
        {isPlaying ? (
          // PAUSE ICON
          <svg width="14" height="14" viewBox="0 0 24 24" fill="white">
            <rect x="6" y="4" width="4" height="16"></rect>
            <rect x="14" y="4" width="4" height="16"></rect>
          </svg>
        ) : (
          // PLAY ICON
          <svg width="14" height="14" viewBox="0 0 24 24" fill="white">
            <polygon points="5,3 19,12 5,21"></polygon>
          </svg>
        )}
      </button>
    </div>
  );
}


// Hero Component
function Hero() {
  const heroRef = useRef(null);

  useEffect(() => {
    return () => {
      const birds = document.getElementById("birds-canvas-holder");

      if (birds) {
        birds.innerHTML = "";
      }
    };
  }, []);	
  // Filtramos las capas para separar la última de las demás
  const backgroundLayers = parallaxLayers.filter(layer => layer.id !== "dwb-8");
  const topLayer = parallaxLayers.find(layer => layer.id === "dwb-8");

  return (
    <div className="dwb" id="parallax" key="hero-home">
      {/* 1. Renderizamos las capas de la 0 a la 7 */}
      {backgroundLayers.map((layer) => (
        <ParallaxLayer key={layer.id} {...layer} />
      ))}

      {/* 2. Insertamos el birds-canvas-holder justo aquí */}
      <div id="birds-canvas-holder" style={{ opacity: 1 }}>
        {/* Si tienes un canvas que se genera dinámicamente, React lo mantendrá aquí */}
      </div>

      {/* 3. Renderizamos la capa 8 (la que va por encima de los pájaros) */}
      {topLayer && <ParallaxLayer key={topLayer.id} {...topLayer} />}

      {/* Resto de elementos */}
      <div className="dwb_layer" id="dwb-scrim" />
      <Particles />

      <div
        className="dwb_layer"
        id="slogan-svg"
        style={{ width: 380, left: "40%", top: 20, display: "none" }}
      />

      <div className="dwb_layer cloud-padding">
        {/* He añadido la lógica de opacidad que mencionaste en tu HTML deseado */}
        <div className="sacar" style={{ paddingTop: 60, opacity: 1 }}> 
          <p className="cloud-title2">living dreams :) <br />_</p>
          <img
            src="images/scroll_down.gif"
            style={{ width: 80, paddingTop: 30 }}
            alt=""
          />
        </div>
      </div>

      <AudioPlayer />
    </div>
  );
}

export default Hero;